import React, { useEffect, useState } from "react";
import { roofColorChange } from "../../action";
import { changeBuildingDimension } from "../../action/building/building_style/buildingStyle.action";
import { connect, useDispatch, useSelector } from "react-redux";
import { const_var, params } from "../../redux/reducers/reducer";

const AlertSize = ({ props, ...restProps }) => {
	const [showAlert, setShowAlert] = useState(true);
	const dispatch = useDispatch();
	const handleHideAlert = () => {
		setShowAlert(false);
	};

	const { buildingWidthArrayCust, buildingLengthArrayCust, DistanceArr } = const_var;
	const { p_w, p_d, p_b_t, p_r_s, isBreezeway } = params;
	let distanceOnCenter = 5;
	if (isBreezeway && DistanceArr.length > 0 && DistanceArr[p_b_t][p_r_s] != undefined) distanceOnCenter = DistanceArr[p_b_t][p_r_s];

	const lengthIncrement = !isBreezeway ? 5 : distanceOnCenter;
	const widthIncrement = !isBreezeway ? 2 : distanceOnCenter;
	let popularSizeArray = [];

	let i = p_d && buildingLengthArrayCust.length > 0 ? buildingLengthArrayCust.findIndex((item) => item.value == p_d) : 0;
	let j = p_w && buildingWidthArrayCust.length > 0 ? buildingWidthArrayCust.findIndex((item) => item.value == p_w) : 0;
	if (buildingLengthArrayCust.length > 0 && buildingWidthArrayCust.length > 0) {
		for (i; i < buildingLengthArrayCust.length; i += lengthIncrement) {
			if (buildingWidthArrayCust[j] === undefined || buildingLengthArrayCust[i + lengthIncrement] === undefined || popularSizeArray.length === 4) break;
			let size = buildingWidthArrayCust[j].value + "x" + buildingLengthArrayCust[i + lengthIncrement].value;
			popularSizeArray.push(size);
		}

		i = p_d && buildingLengthArrayCust.length > 0 ? buildingLengthArrayCust.findIndex((item) => item.value === p_d) : 0;
		for (j; j < buildingWidthArrayCust.length; j += widthIncrement) {
			if (buildingLengthArrayCust[i] === undefined || buildingWidthArrayCust[j + widthIncrement] === undefined || popularSizeArray.length === 8) break;
			let size = buildingWidthArrayCust[j + widthIncrement].value + "x" + buildingLengthArrayCust[i].value;
			if (popularSizeArray.indexOf(size) === -1) {
				popularSizeArray.push(size);
			}
		}
		if (popularSizeArray.length < 8) {
			i = p_d && buildingLengthArrayCust.length > 0 ? buildingLengthArrayCust.findIndex((item) => item.value === p_d) : 0;
			for (i; i < buildingLengthArrayCust.length; i += lengthIncrement) {
				if (buildingWidthArrayCust[j] === undefined || buildingLengthArrayCust[i + lengthIncrement] === undefined || popularSizeArray.length === 8) break;
				let size = buildingWidthArrayCust[j].value + "x" + buildingLengthArrayCust[i + lengthIncrement].value;
				if (popularSizeArray.indexOf(size) === -1) {
					popularSizeArray.push(size);
				}
			}
		}
	}
	let twoDExist = document.getElementsByClassName("twod-map-option-right") != undefined && document.getElementsByClassName("twod-map-option-right")[0] ? true : false;
	return (
		<div>
			{showAlert && (
				<>
					{props == "buildsizes" && popularSizeArray.length > 0 ? (
						<div className={twoDExist ? "info-box info-size twoDExist" : "info-box info-size"} id="pop-size">
							<button type="button" class="info-close" onClick={handleHideAlert}>
								<span className="icon">
									<i className="icon-cross-ico"></i>
								</span>
							</button>
							<div className="info-heading">Popular sizes</div>
							<div className="badge-list-group mb-0 p-sizes">
								{popularSizeArray.length > 0 &&
									popularSizeArray.map((item, index) => {
										let width = item.split("x")[0];
										let length = item.split("x")[1];
										return (
											<div className="badge-item-group">
												<span
													className="badge badge-outline-primary"
													onClick={() => {
														dispatch(
															changeBuildingDimension({
																val: width,
																str: "w",
																checkLean: undefined,
																checkCustomDimension: "checkCustomDimension",
																secondParam: length,
																leftFront: undefined,
																rightFront: undefined,
																leftBack: undefined,
																rightBack: undefined,
																skipCheck: undefined,
																valueToSet: undefined,
																from: {
																	cmp: "popularSizes",
																	val: params.p_h,
																	str: "h"
																}
															})
														);
													}}
													key={index}
												>
													{item}
												</span>
											</div>
										);
									})}
							</div>
						</div>
					) : null}
					{const_var.selSidingOption == "metal" && props == "colors" && const_var?.popular_colors?.length > 0 ? (
						<div className="info-box info-size info-box-md" id="popular-color">
							<button type="button" class="info-close" onClick={handleHideAlert}>
								<span className="icon">
									<i className="icon-cross-ico"></i>
								</span>
							</button>
							<div className="info-heading">Try our popular combos</div>
							<div className="color-group mb-0">
								{const_var?.popular_colors?.map((item, index) => {
									if (index > 6) return;
									let roofRandomColor, wallRandomColor;
									if (const_var.color.length > 0) {
										roofRandomColor = item != undefined && item?.roofColor;
										wallRandomColor = item != undefined && item?.wallColor;
									}
									return (
										<div
											className="color-flex"
											key={index}
											onClick={() => {
												dispatch(roofColorChange("Roof", roofRandomColor));
												dispatch(roofColorChange("Trim", roofRandomColor));
												dispatch(roofColorChange("Wall", wallRandomColor));
											}}
										>
											{roofRandomColor != undefined && (
												<div className="color-item">
													<label className="color-switch" style={{ "background-color": `${roofRandomColor.hex_value}` }}>
														<input type="radio" name="options" value="color" id="color" />
													</label>
												</div>
											)}
											{wallRandomColor != undefined && (
												<div className="color-item">
													<label className="color-switch" style={{ "background-color": `${wallRandomColor.hex_value}` }}>
														<input type="radio" name="options" value="color" id="color" />
													</label>
												</div>
											)}
										</div>
									);
								})}
							</div>
						</div>
					) : null}
				</>
			)}
		</div>
	);
};
const mapStateToProps = (state) => {
	return { ...state.reducer };
};
export default connect(mapStateToProps)(AlertSize);
